import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchUserSettings } from '../../api/userSettingsService';

import { userSettingsKeys } from './keys';

export const userSettingsOptions = () =>
	queryOptions({
		queryKey: userSettingsKeys.list(),
		queryFn: async () => {
			const { data, error } = await fetchUserSettings();
			if (error) throw error;
			return data ?? null;
		},
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});

export function useUserSettings() {
	return useQuery(userSettingsOptions());
}
